<template lang="pug">
  .wrap
    .main
      .main-inner
        .main-header
          .guide-head
            h2 求人検索条件の管理
            a.guide-head-button(@click="openGuide" v-if="user.has_basic && user.new_job_notification") 使い方
          p
            | 求人検索条件は最大50件まで登録することができます。<br />
            | 保存した求人検索条件が上限を超えた場合「削除する」にて既存の条件を整理してご利用ください。
        .blankslate(v-if="!index.length")
          h1 求人検索条件が登録されていません。

        SearchCondition(v-for="(v, i) in index", :condition="v", :index="i", :key="v.id")

    JobNotificationSettingModal
</template>

<script>
  import { mapGetters, mapState } from 'vuex'
  import SearchCondition from './parts/SearchCondition'
  import JobNotificationSettingModal from './parts/JobNotificationSettingModal'

  export default {
    components: { SearchCondition, JobNotificationSettingModal },
    async asyncData ({ store }) {
      await store.dispatch('searchCondition/fetchIndex')
    },
    computed: {
      ...mapGetters({
        index: 'searchCondition/humanizedIndex',
      }),
      ...mapState({
        user: state => state.user.detail,
      }),
    },
    methods: {
      openGuide () {
        window.open('/guide/job_notification_settings', '_blank', 'noreferrer')
      },
    },
  }
</script>



// WEBPACK FOOTER //
// src/components/SearchConditions.vue